/**
 * Ritorna true se il valore di ricerca è "vuoto", ovvero equivalente
 * all'assenza del filtro: null/undefined, stringa vuota, array vuoto o la
 * sua serializzazione JSON `"[]"` (es. `campiSemantici`).
 *
 * Nota: `0` e `false` NON sono considerati vuoti, così da non perdere i
 * filtri numerici/booleani valorizzati.
 *
 * Trade-off accettato: il confronto con `"[]"` si applica a qualsiasi valore,
 * quindi anche la stringa letterale `[]` digitata dall'utente in un campo di
 * ricerca libera viene trattata come filtro vuoto e scartata.
 */
export function isEmptySearchValue(value: unknown): boolean {
  return (
    value == null ||
    value === '' ||
    value === '[]' ||
    (Array.isArray(value) && value.length === 0)
  );
}
